<template>
  <div class="section share-bar light">
    <div class="share-bar__container">
      Share Article via
      <a :href="'mailto:?subject=' + props.pageTitle + '&body=' + props.pageUrl" title="Share to E-mail" aria-label="Share to E-mail" class="share-bar__link" target="_blank" rel="noopener">
        Email
      </a>
      <!-- <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + props.pageUrl + '&title=' + props.pageTitle" target="_blank" title="Share to Facebook" aira-label="Share to Facebook">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40" fill="none">
          <path d="M36.6673 20.1012C36.6673 10.84 29.2062 3.33337 20.0007 3.33337C10.7951 3.33337 3.33398 10.84 3.33398 20.1012C3.33398 28.4723 9.42732 35.4089 17.3962 36.6667V24.9489H13.1651V20.1H17.3962V16.4067C17.3962 12.2045 19.884 9.88226 23.6918 9.88226C25.514 9.88226 27.4229 10.21 27.4229 10.21V14.3367H25.3195C23.2495 14.3367 22.6051 15.63 22.6051 16.9567V20.1012H27.2273L26.4884 24.9478H22.6051V36.6667C30.574 35.4089 36.6673 28.4723 36.6673 20.1012Z" fill="#081F2C"/>
        </svg>
      </a>
      <a :href="'https://twitter.com/intent/tweet?text=' + props.pageTitle + '%20+' + props.pageUrl" target="_blank" title="Share to Twitter" aria-label="Share to Twitter" class="share-bar-buttons__button" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40" fill="none">
          <path d="M33.2548 13.2C33.2751 13.4939 33.2751 13.7877 33.2751 14.0843C33.2751 23.1208 26.3958 33.5426 13.8168 33.5426V33.5372C10.1009 33.5426 6.46216 32.4782 3.33398 30.4713C3.87431 30.5363 4.41733 30.5688 4.96172 30.5702C8.04114 30.5729 11.0325 29.5396 13.4552 27.637C10.5288 27.5815 7.9626 25.6734 7.06613 22.8879C8.09125 23.0856 9.14751 23.045 10.1537 22.7701C6.96321 22.1255 4.66786 19.3223 4.66786 16.0668C4.66786 16.037 4.66786 16.0086 4.66786 15.9802C5.6185 16.5096 6.68289 16.8035 7.77166 16.836C4.76672 14.8277 3.84045 10.8302 5.65506 7.70472C9.1272 11.9772 14.2501 14.5745 19.7495 14.8494C19.1983 12.4742 19.9512 9.98517 21.7279 8.31545C24.4823 5.72625 28.8144 5.85896 31.4036 8.61202C32.9352 8.31004 34.4031 7.74805 35.7465 6.95179C35.2359 8.53483 34.1675 9.87954 32.7402 10.734C34.0957 10.5742 35.4201 10.2113 36.6673 9.65745C35.7492 11.0333 34.5927 12.2318 33.2548 13.2Z" fill="#081F2C"/>
        </svg>
      </a> -->
      <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + props.pageUrl" target="_blank" title="Share to Linkedin" aria-label="Share to Linkedin" class="share-bar__link" rel="noopener">
        LinkedIn
      </a>
    </div>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'
  const props = defineProps({
    pageUrl: String,
    pageTitle: String
  })

  async function copyPageUrl() {
  try {
      await navigator.clipboard.writeText(props.pageUrl);
      console.log('Page URL copied to clipboard');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  function printPage(){
    window.print()
  }

</script>